import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import type { RootState } from '../../../store';

/**
 * 노드가 쓰는 연결이 이 서버에 없으면 그 경고 문구 — 다른 서버에서 옮겨 온 워크플로(테라스트림 이관·프로젝트 불러오기)는
 * 그쪽 연결 이름을 그대로 들고 온다. 실행해 보기 전에 노드에서 「!」 로 알린다.
 * 목록을 아직 받지 못했거나(비어 있음·불러오는 중) 이름에 ${변수} 가 들어 있으면 판단하지 않는다.
 */
export function useConnectionGone(connection?: string): string | undefined {
  const { t } = useTranslation();
  const list = useSelector((s: RootState) => s.connections.list);
  const loading = useSelector((s: RootState) => s.connections.loading);
  if (!connection || connection.includes('${') || loading || list.length === 0) return undefined;
  return list.some((c) => c.connection_id === connection) ? undefined : t('workflow:data.connGone', { id: connection });
}
